import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const IUser = IRecord<UserType>({
  id: 0,
  name: '',
  email: '',
  isActive: true,
  numProjectsCreated: 0,
  numProjectsApproved: 0,
  canBeDeleted: true,
  dateCreated: Date.now(),
  dateUpdated: Date.now()
});

// immutable type
export type IUserType = IRecordType<UserType>;

type UserType = {
  id: number;
  name: string; // [1..20] characters
  email: string; // [1..254] characters
  isActive: boolean;
  numProjectsCreated: number; // 作成したプロジェクトの数
  numProjectsApproved: number; // 承認したプロジェクトの数
  canBeDeleted: boolean;
  dateCreated: number;
  dateUpdated: number;
};
